<script setup>
import PaymentFormCard from "@/components/payments/PaymentFormCard.vue";

defineProps({
  paymentDate: String,
  amount: [String, Number],
  modelValue: String,
  bankName: String,
  referenceNo: String,
  status: String,
  generateReceipt: Boolean,
  note: String,
  methods: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits([
  "update:paymentDate",
  "update:amount",
  "update:modelValue",
  "update:bankName",
  "update:referenceNo",
  "update:status",
  "update:generateReceipt",
  "update:note",
]);
</script>
<template>
  <PaymentFormCard
    title="ข้อมูลการรับชำระ"
    subtitle="กรอกวันที่รับชำระ จำนวนเงิน ช่องทางชำระ และข้อมูลอ้างอิงของรายการ"
    icon="bi-cash-coin"
  >
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label fw-semibold">วันที่รับชำระ</label>
        <input
          type="date"
          class="form-control"
          :value="paymentDate"
          @input="$emit('update:paymentDate', $event.target.value)"
        />
        <div v-if="errors.paymentDate" class="text-danger small mt-1">
          {{ errors.paymentDate }}
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">จำนวนเงินที่รับชำระ</label>
        <input
          type="number"
          min="0"
          class="form-control"
          :value="amount"
          @input="$emit('update:amount', $event.target.value)"
        />
        <div v-if="errors.amount" class="text-danger small mt-1">
          {{ errors.amount }}
        </div>
      </div>

      <div class="col-12">
        <label class="form-label fw-semibold">ช่องทางชำระ</label>
        <div class="row g-3">
          <div
            v-for="item in methods"
            :key="item.value"
            class="col-md-6 col-xl-3"
          >
            <button
              type="button"
              class="method-card"
              :class="modelValue === item.value ? 'active' : ''"
              @click="$emit('update:modelValue', item.value)"
            >
              <i :class="`bi ${item.icon}`"></i>
              <span>{{ item.label }}</span>
            </button>
          </div>
        </div>
        <div v-if="errors.method" class="text-danger small mt-2">
          {{ errors.method }}
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">ธนาคาร / ระบบ</label>
        <input
          type="text"
          class="form-control"
          placeholder="เช่น KBank, PromptPay, KTC"
          :value="bankName"
          @input="$emit('update:bankName', $event.target.value)"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">Reference No.</label>
        <input
          type="text"
          class="form-control"
          placeholder="เช่น TXN-123456, QR-998811"
          :value="referenceNo"
          @input="$emit('update:referenceNo', $event.target.value)"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">สถานะรายการ</label>
        <select
          class="form-select"
          :value="status"
          @change="$emit('update:status', $event.target.value)"
        >
          <option value="completed">รับชำระสมบูรณ์</option>
          <option value="partial">ชำระบางส่วน</option>
          <option value="pending_verify">รอตรวจสอบ</option>
        </select>
      </div>

      <div class="col-md-6 d-flex align-items-end">
        <div class="form-check form-switch mb-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="generateReceipt"
            :checked="generateReceipt"
            @change="$emit('update:generateReceipt', $event.target.checked)"
          />
          <label class="form-check-label" for="generateReceipt">
            ออกใบเสร็จอัตโนมัติหลังบันทึก
          </label>
        </div>
      </div>

      <div class="col-12">
        <label class="form-label fw-semibold">หมายเหตุ</label>
        <textarea
          class="form-control"
          rows="4"
          placeholder="บันทึกรายละเอียดเพิ่มเติม เช่น รายการผ่อนชำระ หรือเงื่อนไขที่ตกลงกับลูกบ้าน"
          :value="note"
          @input="$emit('update:note', $event.target.value)"
        ></textarea>
      </div>
    </div>
  </PaymentFormCard>
</template>

<style scoped>
.method-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 1rem;
  background: #fff;
  min-height: 108px;
  transition: all 0.2s ease;
}

.method-card i {
  font-size: 1.25rem;
}

.method-card.active {
  border-color: #0d6efd;
  background: rgba(13, 110, 253, 0.08);
  color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.08);
}
</style>
